import React, { useEffect, useState } from 'react'
import { getGallery } from '../Common/apis'
import { toast } from 'react-toastify';
import Loader from '../Components/Loader/Loader';

function Gallery() {
    const [gallery, setGallery] = useState(null);
    const [loading, setLoading] = useState(false);


    const fetchGallery = async () => {
        setLoading(true);
        try {
            const response = await getGallery();
            setGallery(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchGallery();
    }, []);

    return (
        <>
        {loading && <Loader />}
            <div className='mt-[80px]'>
                <div className='relative'>
                    <img src="/assets/gallery/bg1.png" className='w-full' alt="" />
                    <div className='absolute md:bottom-[60px] bottom-[10px] left-[50%] translate-x-[-50%]'>
                        <h2 className="font-[700] font-manrope md:text-[50px] text-[30px] text-[#FFFFFF] tracking-[3px] text-center">Gallery</h2>
                        <p className="font-[500] font-manrope text-[16px] text-[#FFFFFF] tracking-[3px] text-center">HOME-Gallery</p>
                    </div>
                </div>
            </div>
            <section className="gallery-section md:pt-[90px] pt-[50px] md:pb-[120px] pb-[50px]">
                <div className='md:px-[75px] px-[20px] grid md:grid-rows-2 grid-rows-1 md:grid-cols-3 grid-cols-1 gap-[30px]'>
                    {gallery && gallery.length > 0 ? (
                        gallery.map((e, i) => (
                            <div key={i} className='row-span-2 relative group w-full overflow-hidden'>
                                <img src={e?.Image} className='w-full h-full' alt="" />
                                <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    <img src="/assets/gallery/arrow-up.svg" alt="up-arrow" className="w-[50px] h-[50px]" />
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-gray-500 py-10 col-span-full">
                            No images found in the gallery.
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}

export default Gallery